import { __assign } from "tslib";
/* I134 in DS */
import React from 'react';
import IconWrap from '../../IconWrap';
var GroupAdmin = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M12.3162 3.1054l5.4598 1.82a1 1 0 01.391.2415l.5401.5402A1 1 0 0119 6.4142v7.0495c0 1.6413-.78 3.174-2.0782 4.0844l-4.3476 3.0492a1 1 0 01-1.1484 0L7.0782 17.548C5.7802 16.6379 5.0004 15.1056 5 13.4645V6.4142a1 1 0 01.2929-.707l.5402-.5403a1 1 0 01.3909-.2416l5.4598-1.8199a1 1 0 01.6324 0zM12 7l-1.7678 3.2322L7 12l3.2322 1.7678L12 17l1.7678-3.2322L17 12l-3.2322-1.7678L12 7z", fillRule: "nonzero" }))));
};
GroupAdmin.displayName = 'GroupAdmin';
export default GroupAdmin;
//# sourceMappingURL=GroupAdmin.js.map